import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

new Swiper('.slider-swiper', {
	modules: [Navigation],
	slidesPerView: "1",
	loop: true,
	grabCursor: true,
	autoHeight: true,
	spaceBetween: 0,
	speed: 800,
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});